module.exports = __webpack_public_path__ + "img/wind.f470d8df.svg";